import { useConfigContext } from "@/app";
import { AutoCenter, Toast } from "antd-mobile";
import { Html5Qrcode } from "html5-qrcode";
import { useEffect, useRef, useState } from "react";
// @ts-ignore
import {
  QRCodeLoginCancel,
  QRCodeLoginConfirm,
  QRCodeLoginScan,
} from "@/apis/user";
import { LINK_ACCOUNT_TOKEN } from "@/constants";
import { useUserInfoStore } from "@/stores/userInfo";
import { decode as decodeBase64 } from "js-base64";
import { useNavigate } from "react-router-dom";
import { DialogLocal } from "../Dialog";

type Result<T = string> = {
  ok: boolean;
  data?: T;
  msg?: string;
};

declare var Instascan:any;

//插入qrcode js
const insertQrcode=(callback:(Instascan:any)=> void)=> {
  let node = document.createElement("script");
  const head = document.head || document.getElementsByTagName("head")[0];
  node.setAttribute('id', 'dx-captcha-script');
  node.async = true;
  node.crossOrigin = "anonymous";
  node.onload = onload;

  function onload() {
      node.onload = null;
      head.removeChild(node);
      callback(Instascan);
  }

  node.src = './js/qrcode.js';
  head.appendChild(node);
}

// 获取摄像头
const getDevices = () => {
  return new Promise<Result>((resolve) => {
    Html5Qrcode.getCameras()
      .then((devices) => {
        try {
          if (devices && devices.length > 0) {
            const deviceId = devices[devices.length - 1].id;
            resolve({ ok: true, data: deviceId });
          } else {
            resolve({ ok: false, msg: "未检测到摄像头！" });
          }
        } catch (err) {
          const msg = typeof err === "string" ? err : JSON.stringify(err);
          resolve({ ok: false, msg });
        }
      })
      .catch((err) => {
        console.error(err);
        resolve({ ok: false, msg: "无法获取摄像头权限！" });
      });
  });
};


const scanByCamera = async (setScanner: (scanner: any) => void) => {
  const { ok, data, msg } = await getDevices();
  return new Promise<Result>((resolve) => {
    if (!ok) {
      resolve({ ok: false, msg: msg || "无法获取摄像头权限！" });
    } else {

      const startQrcode = ()=>{
        try{
          const scanner = new Instascan.Scanner({ video: document.getElementById('reader'), mirror: false });
          Instascan.Camera.getCameras().then((cameras:any) => {
            scanner.camera = cameras[cameras.length - 1];
            scanner.start();
            setScanner(scanner);
          }).catch((e:any)=> {
            console.error(e)
            resolve({
              ok: false,
              msg: "系统错误，唤起扫描失败",
            });
            scanner.stop();
            setScanner(undefined);
          });
        
          scanner.addListener('scan', (content:any) => {
            console.log(content);
            if(content){
              resolve({
                ok: true,
                data: content,
              });
              scanner.stop();
              setScanner(undefined);
            }
          });
        }catch(e){
          console.error(e);
          resolve({
            ok: false,
            msg: "系统错误，唤起扫描失败",
          });
        }
      }

      try{
        if( Instascan && Instascan.Scanner ){
          startQrcode();
        }else{
          insertQrcode(()=>{
            startQrcode();
          });
        }  
      }catch(e){
        insertQrcode(()=>{
          startQrcode();
        });
      }

      // var html5QrcodeScanner = new Html5QrcodeScanner(
      //   "reader",
      //   { fps: 10, qrbox: {width: 200, height: 200} }, false);
      // html5QrcodeScanner.render((decodedText, decodedResult)=>{
      //   console.log(`扫描成功：${decodedText}`);
      // }
      // , (error)=>{
      //   console.error(`扫描失败：${error}`);
      // });

      // console.log('dom==',document.getElementById('reader'));
      
      // const scanner = new Html5Qrcode(/* element id */ "reader",false);
      /*
      scanner
        .start(
          { deviceId: { exact: data } },
          { fps: 10, qrbox: { width: 160, height: 160 } },
          (decodedText, decodedResult) => {
            resolve({
              ok: true,
              data: decodedText,
            });
            scanner.stop();
            setScanner(undefined);
          },
          (errorMessage) => {
            resolve({
              ok: false,
              msg: errorMessage,
            });
            scanner.stop();
            setScanner(undefined);
            // console.error(errorMessage);
          }
        )
        .then(() => {
          if (typeof setScanner === "function") {
            setScanner(scanner);
          }
        })
        .catch((err) => {
          console.error(err);
          resolve({
            ok: false,
            msg: "系统错误，唤起扫描失败",
          });
          scanner.stop();
          setScanner(undefined);
        });
        */

      
    

    }
  });
};

export const useLogic = () => {
  const config = useConfigContext();
  
  const [userInfo] = useUserInfoStore()((state) => [state.userInfo]);
  const [visible, setVisible] = useState<boolean>(false);
  const [scanner, setScanner] = useState<any>(undefined);
  const scannerRef = useRef<any>();
  const navigate = useNavigate();

  // 二维码内容处理
  const processQrcodeResult = (decodedText: string) => {
    if (!decodedText) return Toast.show("解析失败");
    try {
      const _decodeText = decodeBase64(decodedText.replace("vppal://", ""));
      const [type, content] = _decodeText.split("?");
      if (type === "payOrder") {
        // 跳转支付页面
        if (!userInfo) return;
        return navigate(`/pay_order?${content}`);
      }
      if (type === "login") {
        const [, UUID] = content.split("=");
        // 扫码登陆
        if (!userInfo) return;
        QRCodeLoginScan({ uuid: UUID }).then(({ ok, data, msg }) => {
          if (ok) {
            // console.log(JSON.stringify(data));
            DialogLocal({
              title: "新设备登录确认",
              content: (
                <p>
                  您有新的设备:
                  <span style={{ color: "rgb(240, 83, 95)" }}>
                    {data.deviceModel} {data.operatingSystem}
                  </span>
                  将登录账号:
                  <span style={{ color: "rgb(240, 83, 95)" }}>
                    ${data.scannedUserNickname}
                  </span>
                  ,请确认是否登录新设备。
                </p>
              ),
              confirmText: "确认登录",
              cancelText: "取消登录",
              onConfirm() {
                QRCodeLoginConfirm({ uuid: UUID }).then(({ ok, data, msg }) => {
                  Toast.show(msg);
                });
              },
              onCancel: () => {
                QRCodeLoginCancel({ uuid: UUID }).then(({ ok, data, msg }) => {
                  Toast.show(msg);
                });
              },
            });
          } else {
            Toast.show(msg);
          }
        });
        return;
      }
      if (type === "link") {
        const search = new URLSearchParams(content)
        if(search.get('auth')) {
          window.localStorage[LINK_ACCOUNT_TOKEN] = search.get('auth');
          return navigate('/link_account')
        }
      }
      DialogLocal({
        title: "扫描内容",
        content: <AutoCenter>decode text:${_decodeText}</AutoCenter>,
      });
    } catch (error) {
      Toast.show( `无效二维码`);
    }
  };

  //获取二维码内容
  const scanImage = (file: File) => {
    if (!scannerRef.current) {
      scannerRef.current = new Html5Qrcode(/* element id */ "reader");
    }
    return new Promise<Result>((resolve) => {
      console.log('file==',file);
      
      scannerRef.current
        .scanFile(file, { 
          resizeConfig: { 
            maxWidth: 800,  // 限制宽度
            maxHeight: 800  // 限制高度
          },disableFlip: true })
        .then((decodedText: string) => {
          console.log('decodedText==',decodedText);
          
          processQrcodeResult(decodedText as string);
        })
        .catch((err:any) => {
          // failure, handle it.
          if( err?.name ){
            Toast.show( `扫描图片失败,请换清晰的二维码图片扫描 ${err.name}:${err.message}` );
          }else{
            Toast.show( `扫描图片失败,未获取到图片文件，请开启权限后上传` );
          }
          
          const msg = typeof err === "string" ? err : JSON.stringify(err);
          resolve({ ok: false, msg });
        });
    });
  };

  const h5pScan = () => {
    // @ts-ignore
    window.h5p.startQrcodeScan((res) => {
      try {
        const qrInfo = JSON.parse(res);
        if (qrInfo.status) {
          processQrcodeResult(qrInfo.result);
          // this.$root.processQrcodeResult(qrInfo.result);
        } else {
          Toast.show("扫码失败！");
        }
      } catch (error) {
        Toast.show("扫码错误！");
      }
    });
  };
  // 点击扫一扫按钮
  const handleScan = () => {
    console.log('config==',config);
    
    // @ts-ignore;
    if (config.isH5Plus) {
      // 如果是h5pscan
      h5pScan();
    } else {
      //如果不是则弹窗
      setVisible(true);
      // scanImage();
    }
  };

  const startScan = async() => {
    console.log('scanne===',scanner);
    if (scanner) {
      console.log('scanne===',scanner);
      
      scanner.stop();
      setScanner(undefined);
      return;
    }
 
    const { ok, data, msg } = await scanByCamera(setScanner);
    if (ok) {
      processQrcodeResult(data as string);
    } else {
      Toast.show(msg || "扫码失败");
    }

  };
  const cancelScan = () => {
    setVisible(false);
    scanner && scanner.stop();
    setScanner(undefined);
  };
  useEffect(() => {
    if(!visible) {
      scanner && scanner.stop();
      setScanner(undefined);
    };
  }, [visible])
  return {
    visible,
    scanning: scanner !== undefined,
    handleScan,
    scanImage,
    startScan,
    cancelScan,
  };
};
